<template>
    <div class="offer-counter" :class="{'offer-counter--counting': counting}">
        <span class="offer-counter__number"><ICountUp
            :startVal="startVal"
            :endVal="endVal"
            :decimals="0"
            @ready="ready = true"
    /></span>
        <span class="offer-counter__text" v-text="translations.offer_header"></span>
    </div>
</template>

<script type="text/javascript">
    import ICountUp from 'vue-countup-v2';
    export default {
        data() {
            return {
                startVal: 0,
                endVal: 0,
                ready: false,
                translations: APP_CONFIG.TRANSLATION.OFFER_COUNTER,
                counting: false
            }
        },
        methods: {
            doTheCount() {
                this.startVal = this.endVal;
                this.endVal = this.offerCount;
                if(this.startVal > this.endVal) {
                    this.counting = true;
                    setTimeout(() => {
                        this.counting = false;
                    }, 2000);
                }
            }
        },
        watch: {
            offerCount() {
                if(this.ready) {
                    this.doTheCount();
                }
            },
            ready() {
                this.doTheCount();
            }
        },
        computed: {
            offerCount() {
                return this.$store.getters.totalOfferCount;
            }
        },
        components: {
            ICountUp
        }
    }
</script>